import React from 'react';

import HelpIcon from '@material-ui/icons/Help';
import ReactTooltip from 'react-tooltip';
import { roles } from '../services/user';

const InfoCreateQuery = () => {
  if (roles('licenca_de_uso_software_lira_log_perfil.consulta.integrado') &&
  roles('licenca_de_uso_software_lira_log_perfil.cadastro.integrado')) {
    return ( 
      <div style={{ 
        marginLeft: '20px',
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent: 'center'}}>
        <HelpIcon data-for="main"
          style={{color: '#0aafe1'}}
          data-tip='Ao salvar este registro, favor realizar a consulta do mesmo na 
          aba de "Consulta".'
          data-iscapture="true"
        />
        <ReactTooltip
          id="main"
          type="info"
          multiline
          effect="solid"
        />
      </div>
    );
  } else {
    return ( 
      <div style={{ 
        marginLeft: '20px',
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent: 'center'}}>
        <HelpIcon data-for="main"
          style={{color: '#0aafe1'}}
          data-tip="Ao salvar este registro, será criado 
           um cadastro ou consulta <br> junto a sua homologadora."
          data-iscapture="true"
        />
        <ReactTooltip
          id="main"
          type="info"
          multiline
          effect="solid"
        />
      </div>
    );
  }
};

export default InfoCreateQuery;
